import { DELETE, GET, POST, PUT } from './ApiService';
import appConfig from '../config/app-config';
import { getAllBackgrounds, getSpecificBackgroundMock } from './mocks/BackgroundServiceMock';

const baseUrl = `${appConfig.baseUri}/management/v1/Backgrounds`;
export default class BackgroundService {

  static async getAll() {
    if (appConfig.isTest) {
      return { data: getAllBackgrounds(), error: false };
    }

    return GET({
      url: baseUrl,
      token: true,
    });
  }

  static async updateOrder(id, order) {
    return POST({
      url: `${baseUrl}/OrderUpdate`,
      token: true,
      body: { BackgroundId: id, Order: order },
    });
  }

  static async getById(id) {
    if (appConfig.isTest) {
      return { data: getSpecificBackgroundMock(), error: false };
    }

    return GET({
      url: `${baseUrl}/${id}`,
      token: true,
    });
  }

  static async save(request) {
    return POST({
      url: baseUrl,
      token: true,
      body: request,
    });
  }

  static async update(id, request) {
    return PUT({
      url: `${baseUrl}/${id}`,
      token: true,
      body: request,
    });
  }

  static async deleteById(id) {
    return DELETE({
      url: `${baseUrl}/${id}`,
      token: true,
    });
  }

  static async deleteAllById(ids) {
    return POST({
      url: `${baseUrl}/BatchDelete`,
      token: true,
      body: ids,
    });
  }

}
